import { callApi } from '../../utils/apiCaller'
import { INVOICE_PATH, QF_PAY_PATH, QF_PAY_STATUS } from '../routes'

export const fetchInvoice = (invoiceId) => {
  return callApi(`${INVOICE_PATH}/${invoiceId}`, {
    method: 'get',
  })
}

export const fetchInvoices = (invoiceType, offset) => {
  return callApi(`${INVOICE_PATH}`, {
    method: 'get',
    params: {
      offset,
      type: invoiceType,
    },
  })
}

export const payInvoice = (invoiceId, payload) => {
  return callApi(`${INVOICE_PATH}/${invoiceId}`, {
    method: 'post',
    body: {
      ...payload,
    },
  })
}

export const qfPayParams = (invoiceId, method, payload) => {
  return callApi(`${QF_PAY_PATH}`, {
    method: 'post',
    body: {
      invoice_id: invoiceId,
      method,
      ...payload,
    },
  })
}

export const qfPayStatus = (invoiceId, payload) => {
  return callApi(`${QF_PAY_STATUS}/${invoiceId}`, {
    method: 'get',
    body: {
      invoice_id: invoiceId,
      ...payload,
    },
  })
}

export const changePayMethod = (invoiceId) => {
  return callApi(`${INVOICE_PATH}/${invoiceId}`, {
    method: 'put',
    body: {
      type: 'CHANGE_METHOD',
    },
  })
}

export const redirect = async (url) => {
  return new Promise((res, rej) => {
    try {
      if (window && window.location) {
        window.location.href = url
      }
      setTimeout(() => {
        res()
      }, 5000)
    } catch (e) {
      rej()
    }
  })
}

export default {}
